module.exports = __webpack_public_path__ + "static/media/illustration-smiley-face.5353193c.svg";